import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useMediaQuery
} from "@mui/material";
import { useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

const drawerWidth = 220;

const Menu = () => {
const navigate = useNavigate();
const activeMenu = localStorage.getItem("activeMenu");
const handleLogout = async () => {
  await logout();
  navigate("/login");
};

const location = useLocation();

useEffect(() => {

  if (!location.pathname.toLowerCase().includes("declaration")) {
    localStorage.removeItem("activeMenu");
  }

}, [location.pathname]);
  const isMobile = useMediaQuery("(max-width:1024px)");

  const [mobileOpen, setMobileOpen] = useState(false);
  const { role, logout } = useAuth();

  const isActive = (path) => {

  const current = location.pathname.toLowerCase();

  if (path === "/") {
    return current === "/";
  }

  // toutes les pages déclarations
  if (path === "/Déclarations" || path === "/ListeDeclarations") {
    return current.includes("declaration");
  }

  return current.startsWith(path.toLowerCase());
};

  let menuItems = [];

if ((role || '').toUpperCase() === "ADMIN") {
  menuItems = [
    { label:"Accueil", path:"/" },
    { label:"Utilisateurs", path:"/utilisateurs" },
    { label:"Déclarations", path:"/ListeDeclarations" },
    { label:"Paie", path:"/Paie" },
    { label:"Documents", path:"/Documents" },
    { label:"Factures", path:"/FacturePage" }
  ];
} else {
  menuItems = [
    { label:"Accueil", path:"/" },
    { label:"Déclarations", path:"/Déclarations" },
    { label:"Paie", path:"/Paie" },
    { label:"Documents", path:"/Documents" }
  ];
}

  const SidebarContent = (

    <Box
      sx={{
        p:2,
        height:"100%",
        background:"#0f172a",
        display:"flex",
        flexDirection:"column"
      }}
    >

      {/* LOGO */}
      <Box
  component={Link}
  to="/"
  sx={{
    display: "flex",
    justifyContent: "center",
    mb: 3
  }}
>
  <img
    src="/NOVA PORTAGE Main Logo.png"
    alt="Nova Portage"
    style={{
      width: "140px",
      objectFit: "contain"
    }}
  />
</Box>

      <List sx={{ flexGrow:1 }}>

        {menuItems.map((item)=>(
          <ListItemButton
  key={item.path}
  component={Link}
  to={item.path}

  selected={
  item.label === "Déclarations"
    ? activeMenu === "declarations" || isActive(item.path)
    : isActive(item.path)
}

  onClick={()=>setMobileOpen(false)}

  sx={{
    borderRadius:2,
    mb:1,
    color:"#ffffff",

    "& .MuiListItemText-primary":{
      fontWeight:600,
      fontSize:"0.85rem",
      color:"#ffffff"
    },

    "&.Mui-selected":{
      background:"linear-gradient(135deg,#6366f1,#4f46e5)",
      boxShadow:"0 10px 28px rgba(99,102,241,.35)",
      transform:"translateX(6px)"
    },

    "&:hover":{
      background:"rgba(99,102,241,.25)",
      transform:"translateX(4px)"
    }
  }}
>
  <ListItemText primary={item.label}/>
</ListItemButton>
        ))}

      </List>

<Box
  onClick={handleLogout}
  sx={{
    display:"flex",
    alignItems:"center",
    gap:1,
    mt:2,
    p:1.4,
    borderRadius:2,
    cursor:"pointer",
    background:"#ef4444",
    color:"#ffffff",
    fontWeight:700,
    justifyContent:"center",
    transition:"all .2s ease",

    "&:hover":{
      background:"#dc2626",
      transform:"translateX(4px)"
    }
  }}
>

<PowerSettingsNewIcon fontSize="small"/>

<Typography fontSize="0.85rem">
Déconnexion
</Typography>

</Box>
    </Box>

  );

  return (
    <>

      {isMobile && (

        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            background:"#0f172a",
            borderBottom:"1px solid rgba(255,255,255,0.08)"
          }}
        >

          <Toolbar>

            <IconButton
              onClick={()=>setMobileOpen(true)}
              sx={{ color:"#ffffff" }}
            >
              <MenuIcon/>
            </IconButton>

            

          </Toolbar>

        </AppBar>

      )}

      {!isMobile && (

        <Drawer
          variant="permanent"
          sx={{
            width:drawerWidth,
            flexShrink:0,

            "& .MuiDrawer-paper":{
              width:drawerWidth,
              border:"none",
              background:"#0f172a"
            }
          }}
        >
          {SidebarContent}
        </Drawer>

      )}

      {isMobile && (

        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={()=>setMobileOpen(false)}

          sx={{
            "& .MuiDrawer-paper":{
              width:drawerWidth,
              background:"#0f172a"
            }
          }}
        >
          {SidebarContent}
        </Drawer>

      )}

    </>
  );
};

export default Menu;